module.exports = __webpack_public_path__ + "static/media/inserting_linked_list.657b3b4d.png";